import { GET_DISTRICT_LIST } from "../actions/GlobalSearchActions";
import {
  APPROVE_SCHOOL,
  APPROVE_SCHOOL_DATA,
  GET_APPROVED_SCHOOL_FOR_REMOVE,
  GET_APPROVED_SHOOL_LIST,
  GET_ARVE_DETAILS,
  GET_BLOCK_LIST,
  GET_CLUSTER_LIST,
  GET_IMPORT_SCHOOL_BLOCK_DATA,
  GET_IMPORT_SCHOOL_CLUSTER_DATA,
  GET_IMPORT_SCHOOL_SCHOOL_DATA,
  GET_PENDING_SCHOOL_LIST,
  GET_SCHOOL_APPROVE_PENDING_LIST,
  GET_SCHOOL_DATA,
  GET_SCHOOL_DATA_EDIT,
  REJECT_SCHOOL_DATA,
  REMOVE_DATA_SCHOOL_IMPORT,
  UPDATE_SCHOOL,
  GET_VTS_SCHOOL_LIST,
  GET_VTS_SCHOOLS_BY_CLUSTER,
} from "../actions/ImportSchoolsActions";

const initialState = {
  blockList: [],
  clusterList: [],
  schoolList: [],
  pendingSchoolData: [],
  districtList: [],
  schoolData: [],
  arveDetails: [],
  approvedSchoolList: [],
  approvedSchoolListDistrict: [],
  approvalPendingSchoolList: [],
  schoolDataEdit: [],
  // Tab 4: VTS schools
  vtsSchoolList: { count: 0, items: [] },
  vtsSchoolDropdown: [],
};

const ImportSchoolsReducer = function (state = initialState, action) {
  switch (action.type) {
    case GET_IMPORT_SCHOOL_BLOCK_DATA: {
      return {
        ...state,
        blockList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_IMPORT_SCHOOL_CLUSTER_DATA: {
      return {
        ...state,
        clusterList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_IMPORT_SCHOOL_SCHOOL_DATA: {
      return {
        ...state,
        schoolList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_PENDING_SCHOOL_LIST: {
      return {
        ...state,
        pendingSchoolData: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_DISTRICT_LIST: {
      return {
        ...state,
        districtList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_BLOCK_LIST: {
      return {
        ...state,
        blockList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_CLUSTER_LIST: {
      return {
        ...state,
        clusterList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_SCHOOL_DATA: {
      return {
        ...state,
        schoolData: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_ARVE_DETAILS: {
      return {
        ...state,
        arveDetails: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_APPROVED_SCHOOL_FOR_REMOVE: {
      return {
        ...state,
        approvedSchoolList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_APPROVED_SHOOL_LIST: {
      return {
        ...state,
        approvedSchoolListDistrict: action.payload.data
          ? action.payload.data
          : [],
      };
    }
    case GET_SCHOOL_APPROVE_PENDING_LIST: {
      return {
        ...state,
        approvalPendingSchoolList: action.payload.data
          ? action.payload.data
          : [],
      };
    }
    case GET_SCHOOL_DATA_EDIT: {
      return {
        ...state,
        schoolDataEdit: action.payload.data ? action.payload.data : [],
      };
    }
    // Tab 4: VTS schools
    case GET_VTS_SCHOOL_LIST: {
      return {
        ...state,
        vtsSchoolList: action.payload.data
          ? action.payload.data
          : { count: 0, items: [] },
      };
    }
    case GET_VTS_SCHOOLS_BY_CLUSTER: {
      return {
        ...state,
        vtsSchoolDropdown: action.payload.data ? action.payload.data : [],
      };
    }
    case APPROVE_SCHOOL: {
      return { ...state };
    }
    case UPDATE_SCHOOL: {
      return { ...state };
    }
    case APPROVE_SCHOOL_DATA: {
      return { ...state };
    }
    case REJECT_SCHOOL_DATA: {
      return { ...state };
    }
    case REMOVE_DATA_SCHOOL_IMPORT: {
      return { ...state, clusterList: [], schoolList: [], schoolDataEdit: [] };
    }
    case "SET_VTS_SCHOOL_DROPDOWN": {
      return { ...state, vtsSchoolDropdown: action.payload };
    }
    default: {
      return { ...state };
    }
  }
};

export default ImportSchoolsReducer;
